import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import {
	Button,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	InputLabel,
	MenuItem,
	Select,
	FormControl,
	FormControlLabel,
	Switch
} from '@material-ui/core';

import * as Actions from './store/actions';
import * as ActionsDialog from 'app/store/actions';
import * as ProviderActions from 'app/store/actions';

import Error from 'app/fuse-layouts/shared-components/Error';
import { handleSubmitJob } from './util';

const QuickJobForm = props => {
	const dispatch = useDispatch();

	const jobs = useSelector(({ jobs }) => jobs.job.list);
	const job = useSelector(({ jobs }) => jobs.job.job);
	const hash = useSelector(({ providers }) => providers.providers.hash);
	const clusters = useSelector(({ clusters }) => clusters.cluster.list);

	const [selectedCluster, setSelectedCluster] = useState('');
	const [selectedJob, setSelectedJob] = useState('');
	const [disable, setDisable] = useState(true);
	const [filteredClusters, setFilteredClusters] = useState([]);
	const [hashFilter, setHashFilter] = useState([]);
	const [runAsAdmin, setRunAsAdmin] = useState(false);
	const user = useSelector(({ auth }) => auth.user);
	const isAdmin = user.admin;

	useEffect(() => {
		if (props.match && props.match.params.id && !selectedCluster) {
			setSelectedCluster(props.match.params.id);
		}
		if (!hash) {
			dispatch(ProviderActions.getHash());
		}
		if (selectedJob) {
			dispatch(Actions.getJob(selectedJob));
		}
	}, [dispatch, selectedCluster, selectedJob, props.match, hash]);

	useEffect(() => {
		if (clusters && job) {
			const FC = clusters.filter(
				c => c.info.state === 'available' && _.sumBy(c.data.node.group, n => Number(n.count)) >= Number(job.data.nodes)
			);
			setFilteredClusters(FC);
		}
	}, [clusters, job]);

	useEffect(() => {
		if (hash && filteredClusters && job) {
			const HF = filteredClusters.filter(f =>
				f.data.node.group.some(
					o => {
						return (
							o.instance_id &&
							Object.keys(hash).includes(o.instance_id) &&
							Number(hash[o.instance_id].cores) >= Number(job.data.cores) &&
							Number(hash[o.instance_id].gpus) >= Number(job.data.gpus)
						);
					}
				)
			);
			setHashFilter(HF);
		}
	}, [filteredClusters, job, hash]);

	useEffect(() => {
		if (selectedJob && selectedCluster && disable) {
			setDisable(false);
		}
	}, [selectedJob, selectedCluster, disable]);

	const clear = () => {
		setHashFilter([]);
		setSelectedCluster('');
		setSelectedJob('');
		dispatch(Actions.clearJob());
	};

	const submitSelected = (jobId, clusterId, runAsAdmin) => {
		handleSubmitJob(dispatch, Actions, user, jobId, clusterId, runAsAdmin).catch(err =>
			dispatch(
				ActionsDialog.openDialog({
					children: <Error message={err.data.message} />,
					maxWidth: 'xs',
					fullWidth: true,
					onClose: (event, reason) => {
						if (reason !== 'backdropClick') {
							dispatch(ActionsDialog.closeDialog());
						}
					}
				})
			)
		);
		dispatch(ActionsDialog.closeDialog());
		clear();
	}

	const handleCancel = () => {
		dispatch(ActionsDialog.closeDialog());
		clear();
	};

	if (selectedJob && selectedCluster && disable) {
		setDisable(false);
	}

	return (
		<React.Fragment>
			<DialogTitle>Job Submit</DialogTitle>
			<DialogContent>
				<DialogContentText>Selected a Job and a Cluster</DialogContentText>
				<div className="flex flex-row items-center justify-around">
					<FormControl className="w-1/3">
						<InputLabel>Select Job</InputLabel>
						<Select
							id="quick_job_form_quick-job-select"
							value={selectedJob || ''}
							inputProps={{ name: 'quickJob-job-list', id: 'quickJob-job-list' }}
							onChange={e => setSelectedJob(e.target.value)}
						>
							{jobs.length > 0 ? (
								jobs.map((n, i) => (
									<MenuItem id={n.name} key={i} value={n.id}>
										{n.name}
									</MenuItem>
								))
							) : (
								<MenuItem key="no-jobs" value={null}>
									No Jobs
								</MenuItem>
							)}
						</Select>
					</FormControl>
					<FormControl className="w-1/3">
						<InputLabel htmlFor="quickJob-cluster-list">Select Cluster</InputLabel>
						<Select
							id="quick_job_form_quick-cluster-select"
							disabled={!job}
							value={selectedCluster || ''}
							inputProps={{ name: 'quickJob-cluster-list', id: 'quickJob-cluster-list' }}
							onChange={e => setSelectedCluster(e.target.value)}
						>
							{hashFilter.map((n, i) => (
								<MenuItem id={n.name} key={i} value={n.id}>
									{n.name}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					{isAdmin && (
						<FormControl className="w-1/5">
							<FormControlLabel
								value="admin"
								control={<Switch color="primary" />}
								label="Admin"
								labelPlacement="top"
								onChange={e => {
									e.target.checked ? setRunAsAdmin(true) : setRunAsAdmin(false);
								}}
							/>
						</FormControl>
					)}
				</div>
			</DialogContent>

			<DialogActions className="m-16">
				<Button id="quick_job_form_back-btn" onClick={handleCancel} color="primary">
					Back
				</Button>
				<Button
					id="quick_job_form_submit-btn"
					disabled={disable}
					onClick={() => {
						if (job) submitSelected(job.id, selectedCluster, runAsAdmin)
					}}
					color="primary"
				>
					Submit
				</Button>
			</DialogActions>
		</React.Fragment>
	);
};

export default QuickJobForm;
